export default "__VITE_ASSET__c9293802__"